import { Button, ResultPage } from '@elipssolution/harfang';
import getConfig from 'next/config';
import { signOut } from 'next-auth/react';

import { PublicRuntimeConfigType } from '../../types/publicRuntimeConfig';

const NoAccessPage = () => {
	const {
		publicRuntimeConfig: { appName },
	} = getConfig() as PublicRuntimeConfigType;

	return (
		<ResultPage
			status="403"
			title={`Vous n'avez pas accès à ${appName}.`}
			subtitle="Si vous pensez que c'est une erreur, rapprochez vous de votre responsable client."
			extra={[
				<Button
					key="signIn"
					variant="outlined"
					onClick={() => {
						signOut({ callbackUrl: '/' }).catch((signOutError) => {
							throw signOutError;
						});
					}}
				>
					Changer d&apos;utilisateur
				</Button>,
			]}
		/>
	);
};

export default NoAccessPage;
